// extracted by mini-css-extract-plugin
var _1 = "dDT4j3MwLVvU3lAv3Og2";
var _2 = "_7SjOjdFKB5zqv1bKtx3";
export { _1 as "documentationLink", _2 as "documentationLinkIcon" }
export default { "documentationLink": _1, "documentationLinkIcon": _2 }
